import {
  CONTENT_TYPE,
  LEVEL
} from "../../consts";
import type { JavaBasicDate } from "../../types";
import type { Module } from "../../utils/explore";

/* eslint-disable max-len */
export const BlendedCardModule: Module = {
  booked: true,
  coverPublicURL: "https://medias4b2sit.ispfdevelop.com/media/2023-03/01_stereotipi.jpg?VersionId=fEb_N7Hi4VLbbslJltALvWwAt6QqPUHO",
  disabled: false,
  duration: 2346,
  enrollType:"AUTO_ENROLL",
  expirationDate: [2024, 4, 23] as JavaBasicDate,
  id: 0,
  isAutoSubscribeEnable: false,
  isMandatory: false,
  isSurvey:false,
  isTest:false,
  learningActivityNumber: 3,
  learningObjectType: CONTENT_TYPE.BLENDED,
  learningObjectTypology: LEVEL.PATH,
  percentageOfCompletion: "0%",
  prereqOrderNumber: 2,
  shortDescription: "Scopri come definire il tuo pubblico di riferimento, comprendere le esigenze dei tuoi clienti e adattare la tua strategia.",
  status:"N",
  title: "Inbound Marketing",
  toolNumber: 3,
  link: "",
  attributes:[],
  isFavourite:false
};

export const DigitaleCardModule: Module = {
  booked: true,
  coverPublicURL: "https://medias4b2sit.ispfdevelop.com/media/2023-03/01_stereotipi.jpg?VersionId=fEb_N7Hi4VLbbslJltALvWwAt6QqPUHO",
  disabled: false,
  duration: 12145,
  enrollType:"AUTO_ENROLL",
  expirationDate: [2024, 4, 23] as JavaBasicDate,
  id: 11,
  isAutoSubscribeEnable: false,
  isMandatory: true,
  isSurvey:false,
  isTest:false,
  learningObjectType: CONTENT_TYPE.BLENDED,
  learningObjectTypology: LEVEL.PATH,
  percentageOfCompletion: "60%",
  prereqOrderNumber: 3,
  shortDescription: "Scopri come definire il tuo pubblico di riferimento, comprendere le esigenze dei tuoi clienti e adattare la tua strategia.",
  status:"N",
  title: "Inbound Marketing",
  toolNumber: 5,
  link: "",
  attributes:[],
  isFavourite:false
};

export const LiveClassroomCardModule: Module = {
  booked: true,
  coverPublicURL: "https://medias4b2sit.ispfdevelop.com/media/2023-03/01_stereotipi.jpg?VersionId=fEb_N7Hi4VLbbslJltALvWwAt6QqPUHO",
  disabled: false,
  duration: 763,
  enrollType:"AUTO_ENROLL",
  expirationDate: [2024, 4, 23] as JavaBasicDate,
  id: 22,
  isAutoSubscribeEnable: false,
  isMandatory: false,
  isSurvey:false,
  isTest:false,
  learningObjectType: CONTENT_TYPE.BLENDED,
  learningObjectTypology: LEVEL.PATH,
  percentageOfCompletion: "0%",
  prereqOrderNumber: 3,
  shortDescription: "Scopri come definire il tuo pubblico di riferimento, comprendere le esigenze dei tuoi clienti e adattare la tua strategia.",
  status:"N",
  title: "Inbound Marketing",
  toolNumber: 5,
  link: "",
  attributes:[],
  isFavourite:false
};

export const VirtualClassroomCardModule: Module = {
  booked: true,
  coverPublicURL: "https://medias4b2sit.ispfdevelop.com/media/2023-03/01_stereotipi.jpg?VersionId=fEb_N7Hi4VLbbslJltALvWwAt6QqPUHO",
  disabled: false,
  duration: 763,
  enrollType:"AUTO_ENROLL",
  expirationDate: [2024, 4, 23] as JavaBasicDate,
  id: 44,
  isAutoSubscribeEnable: false,
  isMandatory: true,
  isSurvey:false,
  isTest:false,
  learningObjectType: CONTENT_TYPE.BLENDED,
  learningObjectTypology: LEVEL.PATH,
  percentageOfCompletion: "0%",
  prereqOrderNumber: 6,
  shortDescription: "Scopri come definire il tuo pubblico di riferimento, comprendere le esigenze dei tuoi clienti e adattare la tua strategia.",
  status:"N",
  title: "Inbound Marketing",
  toolNumber: 5,
  link: "",
  attributes:[],
  isFavourite:false
};
